<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear agente</h2></v-toolbar-title></pre>
                    </v-toolbar>

                    <v-form class="mt-3">
                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-usuario">
                                    <v-btn color="red" class="white--text" s>
                                        Volver
                                    </v-btn>
                                </router-link>
                            </v-col>
                        </v-row>
                        <datos-personales
                            v-model="agente.usuario"
                            agente="true"
                        >
                            <template v-if="agente.id" v-slot:tab-headers>
                                <v-tab>Comisiones</v-tab>
                                <v-tab>Objetivo de ventas</v-tab>
                                <v-tab>Configuración</v-tab>
                            </template>
                            <template v-if="agente.id" v-slot:tab-items>
                                <v-tab-item>
                                    <v-btn
                                        fab
                                        :loading="isloading"
                                        :disabled="isloading"
                                        color="orange darken-1"
                                        depressed
                                        class="mt-2 mb-4 elevation-1"
                                        @click="openNew"
                                    >
                                        <v-icon class="white--text"
                                            >mdi-account-plus-outline</v-icon
                                        >
                                    </v-btn>

                                    <v-data-table
                                        dense
                                        :headers="headers"
                                        :items="comisiones"
                                        :search="search"
                                        :items-per-page="15"
                                        item-key="id"
                                        class="elevation-1"
                                        :sort-by="['nombre']"
                                        :sort-desc="[false]"
                                    >
                                        <template
                                            v-slot:item.comision="{ item }"
                                        >
                                            <span>
                                                {{ item.comision }}
                                            </span>
                                            <span
                                                v-if="item.tipo_comision == 1"
                                            >
                                                €
                                            </span>
                                            <span v-else> % </span>
                                        </template>
                                        <template v-slot:item.action="{ item }">
                                            <v-icon
                                                @click="openEdit(item)"
                                                small
                                                class="mr-2"
                                                color="#1d2735"
                                                style="font-size: 25px"
                                                title="EDITAR"
                                                >mdi-pencil-outline</v-icon
                                            >

                                            <v-icon
                                                @click="openModal(item)"
                                                small
                                                class="mr-2"
                                                color="red"
                                                style="font-size: 25px"
                                                title="BORRAR"
                                                >mdi-trash-can</v-icon
                                            >
                                        </template>
                                    </v-data-table>
                                </v-tab-item>
                                <v-tab-item>
                                    <ObjetivoComponent
                                        :items="agente.objetivo_ventas"
                                        :id_comercial="agente.id"
                                        @save="
                                            (data) =>
                                                agente.objetivo_ventas.push(
                                                    data
                                                )
                                        "
                                    ></ObjetivoComponent>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                label="Cargo PDF"
                                                v-model="agente.cargo_pdf"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-switch
                                                label="Mostrar en estadísticas"
                                                v-model="agente.estadistica"
                                            ></v-switch>
                                        </v-col>
                                    </v-row>
                                </v-tab-item>
                            </template>
                        </datos-personales>

                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-usuario">
                                    <v-btn color="red" class="white--text" s>
                                        Cancelar
                                    </v-btn>
                                </router-link>
                                <v-btn
                                    v-if="!agente.id"
                                    @click="saveagente"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    v-if="agente.id"
                                    @click="updateagente"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    v-if="agente.id"
                                    @click="deleteagente"
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    >Eliminar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_save" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso white--text"
                    style="background-color: #1d2735; text-align: center"
                >
                    Guardar comisión
                </v-card-title>
                <v-card-text style="text-align: center">
                    <form ref="form_km">
                        <v-row class="mt-3">
                            <v-col cols="12">
                                <h4>Tipo de comisión</h4>
                                <v-btn-toggle
                                    color="primary"
                                    label=""
                                    shaped
                                    v-model="comision.id_tipo"
                                    background-color="white"
                                >
                                    <v-btn text value="1"> Por venta </v-btn>
                                    <v-btn text value="2"> Por cobro </v-btn>
                                </v-btn-toggle>
                            </v-col>

                            <v-col cols="12">
                                <v-select
                                    v-model="comision.periodo_comision"
                                    :items="periodos_comision"
                                    label="Tipo"
                                    item-text="label"
                                    item-value="id"
                                ></v-select>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field
                                    v-model="comision.desde"
                                    label="Cantidad desde"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="comision.hasta"
                                    label="Cantidad hasta"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <div style="display: flex">
                                    <v-text-field-comma
                                        v-model="comision.comision"
                                        label="Comisión"
                                    >
                                    </v-text-field-comma>
                                    <v-btn-toggle
                                        color="primary"
                                        shaped
                                        v-model="comision.tipo_comision"
                                        background-color="white"
                                    >
                                        <v-btn text>
                                            <v-icon>mdi-percent</v-icon>
                                        </v-btn>
                                        <v-btn text>
                                            <v-icon>mdi-currency-eur</v-icon>
                                        </v-btn>
                                    </v-btn-toggle>
                                </div>
                            </v-col>
                            <!-- <v-col cols="12">
                                <v-text-field
                                    prepend-icon="mdi-percent"
                                    v-model="comision.comision"
                                    label="Comision"
                                ></v-text-field>
                            </v-col> -->
                        </v-row>
                    </form>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="error" large @click="dialog_save = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="saveComision()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_km" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog_km = false;
                            comision_id = null;
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteKm()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import DateSelect from "../../../components/general/dateSelect.vue";
import { debounce } from "../../../helpers";
import DatosPersonales from "../../usuarios/componentes/DatosPersonales.vue";
import ObjetivoComponent from "./ObjetivoComponent.vue";
export default {
    components: {
        DatosPersonales,
        DateSelect,
        ObjetivoComponent,
    },
    data() {
        return {
            search: "",
            periodos_comision: [
                {
                    id: 1,
                    label: "Mensual",
                },
                {
                    id: 2,
                    label: "Trimestral",
                },
            ],
            dialog_save: false,
            comision: {
                id: null,
                id_tipo: null,
                tipo_comision: 1,
                periodo_comision: 1,
            },
            headers: [
                {
                    text: "Cantidad desde",
                    align: "left",
                    value: "desde",
                },
                {
                    text: "Cantidad hasta",
                    align: "left",
                    value: "hasta",
                },
                {
                    text: "Comisión",
                    align: "left",
                    value: "comision",
                },
                {
                    text: "Tipo",
                    align: "left",
                    value: "tipo",
                },
                {
                    text: "Periodo",
                    align: "left",
                    value: "periodo",
                },
                {
                    text: "Acciones",
                    align: "left",
                    value: "action",
                },
            ],
            selected_km: {},
            required_val: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
            ],
            headers_comisiones: [
                {
                    text: "Porcentaje",
                    value: "porcentaje",
                    sortable: false,
                },
                {
                    text: "Emisora/Canal",
                    value: "canal.nombre",
                    sortable: false,
                },
                {
                    text: "Cliente",
                    value: "cliente.razon_social",
                    sortable: false,
                },

                {
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                },
            ],
            menu: false,
            dialog: false,
            delete_dialog: false,
            direccion_dialog: false,
            delete_direccion_dialog: false,

            comision: {
                porcentaje: null,
                id_cliente: null,
                id_canal: null,
            },
            agente: {
                usuario: {
                    direccion: {},
                },
            },
            tiposAgente: [],
            comisiones: [],

            tiposDirecciones: [],
            dialog_km: false,
            comision_id: null,
        };
    },
    watch: {
        "comision.id_tipo"(val) {
            //console.log(val);
        },
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
    },
    created() {
        if (this.$route.query.id) {
            //console.log("agente");
            this.getagente(this.$route.query.id);
        }
        this.$store.dispatch("getClientes", this);
    },
    methods: {
        deleteUser() {
            axios
                .get(
                    `api/delete-agente-comision/${
                        this.comisiones[this.selectedItem].id
                    }`
                )
                .then(
                    (res) => {
                        this.$toast.sucs("Comisión eliminada con éxito");
                        this.dialog = false;
                        this.getComisiones();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando la comisión");
                    }
                );
        },
        openNew() {
            this.comision = {};
            this.dialog_save = true;
        },
        openEdit(item) {
            this.comision = item;

            this.dialog_save = true;
        },
        saveComision() {
            this.comision.id_agente = this.agente.id;
            axios
                .post("api/save-agente-comision", this.comision)
                .then((res) => {
                    this.getComisiones();
                    this.dialog_save = false;
                });
        },
        getComisiones() {
            axios
                .get(`api/get-agente-comisiones?id_agente=${this.agente.id}`)
                .then(
                    (res) => {
                        this.comisiones = res.data;
                    },
                    (err) => {
                        this.$custom_error("Error consultando la comisión");
                    }
                );
        },
        Deletos(item) {
            this.dialog_km = true;
            this.comision_id = item.id;
        },
        deleteKm() {
            axios
                .get(`api/delete-agente-comision/${this.comision_id}`)
                .then((res) => {
                    this.dialog_km = false;
                    this.agente.km = res.data;
                });
        },
        saveKm() {
            let formdata = new FormData(this.$refs.form_km);
            formdata.append("id_agente", this.agente.id);
            formdata.set("fecha", this.selected_km.fecha);
            axios.post("api/save-agente-comision", formdata).then((res) => {
                this.agente.km = res.data;
            });
        },
        SearchCliente: debounce(function (val) {
            this.$store.dispatch("searchCliente", val);
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getClientesNext", this);
            }
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        getagente(agente_id) {
            axios.get(`api/getagente/${agente_id}`).then(
                (res) => {
                    this.agente = res.data;
                    if (this.agente?.usuario != null) {
                        this.agente.usuario.hora_extra = (
                            this.agente.usuario.hora_extra ?? ""
                        ).replace(".", ",");
                    }
                    this.nacimiento = res.data.nacimiento;
                    this.fecha_alta = res.data.fecha_alta;
                    this.getComisiones();
                },
                (res) => {}
            );
        },
        updateagente() {
            if (this.agente?.usuario != null) {
                this.agente.usuario.hora_extra = (
                    this.agente.usuario.hora_extra ?? ""
                ).replace(",", ".");
            }
            axios
                .post("api/update-agente", this.agente)
                .then((res) => {
                    this.$router.push("lista-usuario");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.message);
                    } else {
                        this.$custom_error(error.response.data.message);
                    }
                });
        },
        saveagente() {
            if (this.agente?.usuario != null) {
                this.agente.usuario.hora_extra = (
                    this.agente.usuario.hora_extra ?? ""
                ).replace(",", ".");
            }
            axios
                .post("api/save-agente", this.agente)
                .then((res) => {
                    this.$router.push("lista-usuario");
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.message);
                    } else {
                        this.$custom_error(error.response.data.message);
                    }
                });
        },
        deleteagente() {
            axios
                .post("api/delete-agente", {
                    id: this.agente.id,
                })
                .then(
                    (res) => {
                        this.$router.push("lista-usuario");
                    },
                    (res) => {}
                );
        },
        openModal(item) {
            this.selectedItem = this.comisiones.indexOf(item);
            this.dialog = true;
        },
        openDeleteDialog(id) {
            this.comision.id = id;
            this.delete_dialog = true;
        },
        openDialog() {
            this.comision.id = null;
            this.comision.nombre = "";
            this.dialog = true;
        },
    },
    filters: {},

    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
        canales() {
            return this.$store.getters.getcanales;
        },
        clientes() {
            /////console.log("siva");
            let clientes_temp = this.$store.getters.getclientes;

            return clientes_temp;
        },
    },
};
</script>
